import { Box, FormControlLabel, FormLabel, Modal, Radio, RadioGroup } from '@mui/material'
import React from 'react'

const dialogStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    hight :'auto', 
    minWidth: '400px',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    maxHeight: '100vh',
    overflow: 'auto',
  };

function ConfigurationView({ open = true, setOpen ,
    configuration = { questionType: "normal" }, setConfiguration
}) {
    // console.log(configuration)

  const handleQuestionTypeChange = (event) => {
    setConfiguration((prevConfig) => ({
      ...prevConfig,
      questionType: event.target.value,
    }));
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box sx={dialogStyle}>
        <FormLabel >Question type</FormLabel>
        <RadioGroup
          defaultValue="normal"
          name="question-type"
            value={configuration.questionType}
            onChange={handleQuestionTypeChange}
        >
          <FormControlLabel value="normal" control={<Radio />} label="Normal" />
          <FormControlLabel value="bio" control={<Radio />} label="Bio A B C D E" />
          <FormControlLabel value="chem1" control={<Radio />} label="Chemistry Two Sentences" />
          <FormControlLabel value="chem2" control={<Radio />} label="Chemistry A B C D" />
        </RadioGroup>
      </Box>
    </Modal>
  );
}

export default ConfigurationView